import {Component} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BusinessRulesService} from "../../../core/business-rules/business-rules.service";
import {MegamillionsRules} from "./megamillions-rules";
import {MessageService} from "primeng/components/common/messageservice";

@Component(
  {
    selector: "gl-megamillions-rules",
    templateUrl: "./megamillions-rules.component.html",
    styleUrls: ["./megamillions-rules.component.scss"]
  }
)
export class MegamillionsRulesComponent {

  megamillionsForm: FormGroup;

  constructor(formBuilder: FormBuilder,
              private businessRulesService: BusinessRulesService,
              private messageService: MessageService) {
    this.megamillionsForm = formBuilder.group({
      drawDate: [new Date(), Validators.required],
      closeDrawDate: [new Date(), Validators.required],
      wagerCost: ['', Validators.required],
      wagerPercent: ['', Validators.required],
    });

    businessRulesService.getMegamillionsRules().subscribe((rules: MegamillionsRules) => {
      console.log("Megamillions server rules");
      console.log(rules);
      this.megamillionsForm.setValue({
        drawDate: new Date(rules.wagerDrawDate),
        closeDrawDate: new Date(rules.closeWagerDrawDate),
        wagerCost: rules.wagerCost,
        wagerPercent: rules.wagerPercent
      })
    });
  }

  onSubmit() {
    let form = this.megamillionsForm.value;
    this.businessRulesService.updateMegamillionsRules({
      wagerDrawDate: form.drawDate.getTime(),
      closeWagerDrawDate: form.closeDrawDate.getTime(),
      wagerCost: form.wagerCost,
      wagerPercent: form.wagerPercent,
    }).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary: '',
        detail: 'La actualizacion fue satisfactoria.'
      });
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/businessRules/megamillions-rules/megamillions-rules.component.ts